var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19",
    "data-name": "Group 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.666,
    height: 29.194,
    viewBox: "0 0 24.666 29.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(17.892 19.637)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1088.083,2782.217c.186,3.63,2.714,6.518,5.8,6.518h4.169l-.884,1.421h-2.237a.523.523,0,0,0-.471.562v1.914a.523.523,0,0,0,.471.562h11.1a.523.523,0,0,0,.471-.562v-1.914a.523.523,0,0,0-.471-.562h-1.817l-.769-1.421h3.454c3.09,0,5.619-2.888,5.8-6.518a.636.636,0,0,0,.018-.107.594.594,0,0,0-.011-.064c0-.085.011-.169.011-.255v-10.848c0-3.829-2.612-6.943-5.823-6.943h-13.02c-3.211,0-5.823,3.115-5.823,6.943v10.848c0,.086.008.169.01.255a.564.564,0,0,0-.01.064A.636.636,0,0,0,1088.083,2782.217Zm17.485,9.853h-10.161v-.791h10.161Zm-7.221-1.914.839-1.348h3.184l.73,1.348Zm8.562-2.545h-13.021c-2.439,0-4.46-2.146-4.818-4.938h22.657C1111.368,2785.464,1109.348,2787.611,1106.908,2787.611Zm-17.9-16.667c0-3.208,2.189-5.819,4.88-5.819h13.02c2.691,0,4.88,2.611,4.88,5.819v10.6h-22.781Z",
    transform: "translate(-1088.065 -2764)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenings);
export default __webpack_public_path__ + "static/media/screenings.4aae148d9e4b918d71edbf25f951f758.svg";
export { ForwardRef as ReactComponent };